import Vue from 'vue'

const SpeechSynthesis = Vue.extend({
    methods: {
        speech(text = "") {
            const synthesis = window.speechSynthesis;
            if (!synthesis) {
                console.debug('speechSynthesis is not available')
                return
            }

            const voices = synthesis.getVoices();
            const voice = voices.filter(v => v.default);

            if (voice) {
                const utterThis = new SpeechSynthesisUtterance();
                utterThis.text = text;
                utterThis.lang = 'es';
                synthesis.speak(utterThis);
            }
        },
        readText(text: string){
            this.speech(text)
        },
        stopAndRemoveText() {
            const synthesis = window.speechSynthesis;
            synthesis.cancel();
        }
    },
});

export default SpeechSynthesis
